export default __webpack_public_path__ + "static/media/pattern2a.86b285a2.svg";